// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3upp7","info":"Note_info__IDBXI","note":"Note_note__1waiM","actions":"Note_actions__2wNnx"};